import { useState } from 'react';
import LovemoHeader from '@/components/feature/LovemoHeader';
import LovemoFooter from '@/components/feature/LovemoFooter';
import LovemoDownloadModal from '@/components/feature/LovemoDownloadModal';
import LovemoHero from '@/pages/home/components/LovemoHero';
import LovemoFeatures from '@/pages/home/components/LovemoFeatures';
import LovemoScreenshots from '@/pages/home/components/LovemoScreenshots';
import LovemoDownloadGuide from '@/pages/home/components/LovemoDownloadGuide';
import LovemoReviews from '@/pages/home/components/LovemoReviews';
import LovemoFaq from '@/pages/home/components/LovemoFaq';
import LovemoCta from '@/pages/home/components/LovemoCta';
import { useLovemoTheme } from '@/hooks/useLovemoTheme';
import { useLovemoConfig } from '@/hooks/useLovemoConfig';
import { useLovemoReveal } from '@/hooks/useLovemoReveal';

export default function Home() {
  const { theme, toggleTheme } = useLovemoTheme();
  const { config } = useLovemoConfig();
  const [downloadOpen, setDownloadOpen] = useState(false);

  useLovemoReveal();

  const openDownload = () => setDownloadOpen(true);
  const closeDownload = () => setDownloadOpen(false);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <LovemoHeader theme={theme} onToggleTheme={toggleTheme} onDownload={openDownload} />

      <main>
        <LovemoHero onDownload={openDownload} />
        <LovemoFeatures />
        <LovemoScreenshots />
        <LovemoDownloadGuide />
        <LovemoReviews />
        <LovemoFaq />
        <LovemoCta />
      </main>

      <LovemoFooter />
      <LovemoDownloadModal open={downloadOpen} onClose={closeDownload} config={config} />
    </div>
  );
}